export const themeTypes = {
  amber: "dark",
  forest: "dark",
  "aurora-borealis": "dark",
  cauldron: "dark",
  charcoal: "dark",
  sorbet: "light",
  moonbeam: "light",
  sepia: "light",
};

// Get the effective theme (either direct or from system preference)
export const getEffectiveTheme = (theme) => {
  if (theme === "sorbet-auto") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "charcoal" : "sorbet";
  }
  return theme;
};

// Get the theme type (dark/light) for a given theme
export const getThemeType = (theme) => {
  const effectiveTheme = getEffectiveTheme(theme);
  return themeTypes[effectiveTheme] || "light";
};

// Applies a theme to the body
export function applyTheme(theme) {
  if (!theme) return;

  // Apply theme attributes once
  const effectiveTheme = getEffectiveTheme(theme);
  document.body.setAttribute("data-theme-source", theme);
  document.body.setAttribute("data-theme", effectiveTheme);
  document.body.setAttribute("data-theme-type", themeTypes[effectiveTheme]);
}

export function unapplyTheme() {
  document.body.removeAttribute("data-theme-source");
  document.body.removeAttribute("data-theme");
  document.body.removeAttribute("data-theme-type");
}
